angular.module("vgresiduos").factory("auditService", [
	"$rootScope",
	"$http",
	"permissionService",
	"accountService",
	function ($rootScope, $http, permissionService, accountService) {
		"use strict";

		const _listAudits = function listAudits() {
			const client = accountService.getCurrentClient();
			const organizationId = client.organization.id;

			const req = {
				method: "get",
				url: `${Vgr.constants.suppliersHostUrl}
					${Vgr.resources.suppliers.supplierViewAudits.replace("[ORGANIZATION]", organizationId).replace("[UNIT]", client.id)}`
			};
			return $http(req);
		};

		const _getDefaultAuditLevelDescription = function (level) {
			if (level == 1) {
				return $rootScope.labels.AUDIT_LEVEL1_TOOLTIP;
			} else if (level == 2) {
				return $rootScope.labels.AUDIT_LEVEL2_TOOLTIP;
			} else if (level == 3) {
				return $rootScope.labels.AUDIT_LEVEL3_TOOLTIP;
			}
			return null;
		};

		//UTIL
		function _loadClientClassification(audit) {
			let classification = audit.Classification;
			if (!classification) {
				classification = audit.classification;
			}
			switch (classification) {
				case Vgr.enumerations.audit.Classification.Approved:
				case Vgr.enumerations.audit.ClassificationText.Approved:
					audit.ClassificationDescription = $rootScope.labels.APPROVED;
					audit.ClassificationImg = "img/userApproved.png";
					break;
				case Vgr.enumerations.audit.Classification.ApprovedWithRestrictions:
				case Vgr.enumerations.audit.ClassificationText.ApprovedWithRestrictions:
					audit.ClassificationDescription = $rootScope.labels.APPROVED_WITH_RESTRICTIONS;
					audit.ClassificationImg = "img/userApprovedWithRestrictions.png";
					break;
				case Vgr.enumerations.audit.Classification.Disapproved:
				case Vgr.enumerations.audit.ClassificationText.Disapproved:
					audit.ClassificationDescription = $rootScope.labels.DISAPPROVED;
					audit.ClassificationImg = "img/userRepproved.png";
					break;
				case Vgr.enumerations.audit.Classification.Recovery:
				case Vgr.enumerations.audit.ClassificationText.Recovery:
					audit.ClassificationDescription = $rootScope.labels.RECOVERY;
					audit.ClassificationImg = "img/recovery.png";
			}
			return audit;
		}

		function _hasAnyLevelPermission() {
			const permissions = [
				Vgr.systemPermissions.SupplierOrganizationMaster,
				Vgr.systemPermissions.SupplierOrganizationAuditLevel1,
				Vgr.systemPermissions.SupplierOrganizationAuditLevel2,
				Vgr.systemPermissions.SupplierOrganizationAuditLevel3,
				Vgr.systemPermissions.SupplierAuditLevel1,
				Vgr.systemPermissions.SupplierAuditLevel2,
				Vgr.systemPermissions.SupplierAuditLevel3
			];
			return permissions.some((p) => permissionService.hasPermissionV2(p));
		}

		return {
			hasAnyLevelPermission: _hasAnyLevelPermission,
			getDefaultAuditLevelDescription: _getDefaultAuditLevelDescription,
			listAudits: _listAudits,
			loadClientClassification: _loadClientClassification
		};
	}
]);
